export default __webpack_public_path__ + "static/media/gc-green-black@2x.9a4330be.png";